import React, { useState, useEffect } from 'react';
import { useTheme, makeStyles } from '@material-ui/core/styles'
import { Box, CircularProgress, List, ListItem, Typography, Button, TextField, DialogContent, Dialog } from '@material-ui/core'
import { useTranslate, useDataProvider, Loading, usePermissions } from 'react-admin';
import { useHistory } from 'react-router-dom';
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import { Add, Clear, Close, DeleteOutline } from '@material-ui/icons'
import ActionItem from './ActionItem'
import icBlueAdd from '../assets/icons/icBlueAdd.png'
import icTv from '../assets/icons/Generate-tv-channel.png'
import icPen from '../assets/icons/pen.png'
import icDelete from '../assets/icons/Trash-black.png'
import { Link } from "react-router-dom";
import Snackbar from '../common/snackbar';
import icArrowUp from '../assets/icons/white-arrow-up.png';
import icArrowDown from '../assets/icons/white-arrow-down.png';
import PrimaryButton from '../common/button/primary-button'
import Checkbox from '../checkbox'
import Search from '../search'
import { StyledButton } from '../common/table/index'
const useStyles = makeStyles(theme => ({
    tableSortLabel: {
        color: 'theme.palette.common.white',
        '&:hover': {
            color: 'white'
        },
        '&:focus': {
            color: 'white'
        },
    },
    textEdit: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    dialogContent: {
        padding: '20px 8px !important'
    },
    icons: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: 7,
        cursor: 'pointer'
    },
    icon: {
        width: 9,
        height: 9
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }
}));

const InfoChannels = () => {
    const dataProvider = useDataProvider()
    const classes = useStyles()
    const translate = useTranslate()
    const [data, setData] = useState([])
    const [click, SetClick] = useState(false)
    const { permissions, loaded } = usePermissions();
    const [openConfirmDialog, setOpenConfirmDialog] = useState({
        status: false,
        index: -1
    })
    const [loading, setLoading] = useState(false)
    const [showMessagePopup, setMessagePopup] = useState(false)
    const [showSnackbarEdit, setShowSnackbarEdit] = useState({
        name: '',
        message: '',
        status: false
    })
    const [filter, setFilter] = useState('')
    const [dataFilter, setDataFilter] = useState([])
    const [messagePopupContent, setMessagePopupContent] = useState('')
    const history = useHistory();
    const theme = useTheme()

    const getList = () => {
        setLoading(true)
        dataProvider('GET_LIST', "infochannels", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setData(data);
                setDataFilter(data)
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            })
    }

    React.useEffect(() => {
        getList()
    }, [])

    const onCancel = (index) => {
        let temps = data.slice()
        temps[index].edit = false
        delete temps[index].editName
        setData(temps)
    }

    const onClick = () => {
        setDataFilter(dataFilter.reverse())
        SetClick(!click)
    }
    const handleOutFocus = (value, index) => {
        if (value.length > 0) {
            var temps = data.slice()
            if (data[index].name === data[index].editName) {
                temps[index].edit = false
                setData(temps)
            }
            else {

                temps[index].loading = true
                setData(temps)
                temps = data.slice()
                dataProvider('UPDATE', "infochannels", {
                    id: data[index].id,
                    data: {
                        name: temps[index].editName.trim()
                    }
                })
                    .then(() => {
                        temps[index].name = temps[index].editName
                        delete temps[index].editName
                        temps[index].edit = false
                        delete temps[index].loading
                        setData(temps)
                        setShowSnackbarEdit({
                            name: temps[index].name,
                            message: translate(`pos.categories.editFolder.success`),
                            status: true
                        })
                        setTimeout(() => {
                            setShowSnackbarEdit({
                                name: '',
                                message: '',
                                status: false
                            })
                        }, 6000);

                    })
                    .catch(error => {
                        delete temps[index].loading
                        if (error.message === 'channel name is exist!')
                            temps[index].error = 'name exist'
                        else
                            temps[index].error = 'rename failed'
                        setData(temps)
                    })
            }

        }
    }

    const handleOnDelete = () => {
        if (openConfirmDialog.index > -1) {
            dataProvider('DELETE', "infochannels", {
                id: data[openConfirmDialog.index].id
            })
                .then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
                .catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                })
        }
        else {
            var requests = []
            dataFilter.forEach(element => {
                element.checked && requests.push(
                    dataProvider('DELETE', "infochannels", {
                        id: element.id
                    })
                )
            })
            if (requests.length > 0) {
                Promise.all(requests).then(() => {
                    getList()
                    setOpenConfirmDialog({ status: false, index: -1 })
                }).catch(error => {
                    setOpenConfirmDialog({ status: false, index: -1 })
                });
            }
            else
                setOpenConfirmDialog({ status: false, index: -1 })

        }

    }

    const handleClickReName = (name, index) => {
        let temps = data.slice()
        temps[index].edit = true
        temps[index].editName = name
        setData(temps)
    }

    const onChangeText = (event, index) => {
        let temps = data.slice()
        if (event.target.value.length === 0)
            temps[index].error = 'required'
        else
            delete temps[index].error
        temps[index].editName = event.target.value
        setData(temps)
    }

    const handleClickGenerateTVChannel = (infochannel, index) => {
        infochannel.loading = true;
        var temps = data.slice()
        temps[index] = infochannel
        setData(temps)
        dataProvider('CREATE', "generatetvchannel", { data: { infochannel: infochannel.id } })
            .then((data) => {
                delete infochannel.loading;
                console.log('handleClickGenerateTVChannel', data);
                setMessagePopupContent(`Generate TV channel success with id ${data.data.id}`);
                setMessagePopup(true);
                setTimeout(() => setMessagePopup(false), 6000)
                setData(temps)
            })
            .catch(error => {
                delete infochannel.loading;
                setData(temps)
            })
    }

    const onCloseMessagePopup = () => {
        setMessagePopup(false);
    }

    const handleCheckMark = (event, index, checkAll) => {
        let temps = dataFilter.slice()
        if (!checkAll)
            temps[index].checked = event.target.checked
        else
            temps.map(item => {
                item.checked = event.target.checked
                return item
            })
        setDataFilter(temps)
    }


    const onClear = () => {
        let temps = dataFilter.slice()
        temps.map(item => {
            delete item.checked
            return item
        })
        setDataFilter(temps)
    }

    const onActionMenuClick = (item) => {
        history.push('/infochannel/' + item.id);

    }
    const submitFilter = () => {
        setDataFilter(data.filter(item => item.name.toUpperCase().includes(filter.toUpperCase()) || item.id.toString().toUpperCase().includes(filter.toUpperCase())))
    }

    const checkPermission = () => {
        if (!permissions.functionAction.find(value => value.function === 'Info channel (Management)' && value.isUpdate)) return true
        return false
    }

    if (loading || !loaded) return <Loading />
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='60%' mt={8}>
                <Box width='100%' display='flex' justifyContent='flex-end' mt={2}>
                    <Snackbar
                        show={showSnackbarEdit.status}
                        boldText={showSnackbarEdit.name}
                        message={showSnackbarEdit.message}
                        onClose={() => setShowSnackbarEdit({
                            status: false,
                            message: '',
                            name: ''
                        })}
                    /></Box>
                <Box width='100%' display='flex' alignItems='center'>
                    <Box flexGrow={1} display="flex" flexDirection="row" alignItems="center" >
                        <Typography variant='h5' style={{ fontFamily: 'UniviaPro-Medium', lineHeight: '21.6px', color: '#4f5064', fontWeight: 500 }}>{translate(`resources.room.infoChannels`)}</Typography>
                        {
                            dataFilter.length > 0 ? <Typography className={classes.subText}>({dataFilter.length})</Typography>
                                : <Typography className={classes.subText}>(0)</Typography>
                        }
                    </Box>
                    <Search
                        placeholder={'Info channel'}
                        onChangeText={setFilter}
                        getList={submitFilter}
                    />
                    {
                        permissions.functionAction.find(value => value.function === 'Info channel (Management)' && value.isUpdate) &&
                        <Box ml={4}>
                            <Button variant='contained' color='primary'
                                component={Link}
                                to={{
                                    pathname: "/InfoChannel/create"
                                }}
                            >
                                <Typography style={{ fontSize: '9px', lineHeight: '11px', letterSpacing: '0.36px', fontFamily: 'UniviaPro-Bold' }}> {translate(`pos.infochannel.title`)}</Typography>

                                <Add />
                            </Button>

                        </Box>
                    }

                </Box>
                <Box>
                    <Box display='flex' px={3} py={1} mt={1} bgcolor={dataFilter.filter(item => item.checked).length > 0 ? '#56657f' : theme.palette.primary.main}>
                        <Box flexGrow={1} display='flex' alignItems='center'>
                            <Box style={{ visibility: checkPermission() ? "hidden" : "visible" }} minWidth={dataFilter.filter(item => item.checked).length > 0 ? 20 : 100}>
                                <Checkbox checked={dataFilter.length > 0 && dataFilter.length === dataFilter.filter(item => item.checked).length ? true : false} onChange={(event) => handleCheckMark(event, -1, true)}></Checkbox>
                            </Box>
                            {
                                dataFilter.filter(item => item.checked).length > 0 ?
                                    <Box display='flex' justifyContent='space-between' width='100%'>
                                        <StyledButton
                                            onClick={() => {
                                                setOpenConfirmDialog({
                                                    status: true,
                                                    index: -1
                                                })
                                            }}
                                            variant='text'
                                            startIcon={<DeleteOutline />}
                                        >
                                            {translate(`pos.common.delete`)}
                                        </StyledButton>
                                        <StyledButton
                                            onClick={onClear}
                                            variant='text'
                                            startIcon={<Clear />}
                                        >{dataFilter.filter(item => item.checked).length} {dataFilter.filter(item => item.checked).length > 1 ? translate('pos.categories.filesSelected') : translate('pos.categories.fileSelected')}</StyledButton>
                                    </Box>
                                    :
                                    <Box width='100%' display='flex'>
                                        <Typography
                                            style={{ width: 50, cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                            variant='body1'>
                                            {translate(`pos.infochannel.id`)}
                                        </Typography>
                                        <Typography
                                            style={{ cursor: 'pointer', color: 'white', fontSize: '13px', lineHeight: '16.3px', letterSpacing: '0.13px', fontFamily: 'UniviaPro' }}
                                            variant='body1'>
                                            {translate(`pos.infochannel.name`)}
                                        </Typography>
                                        <div className={classes.icons}>
                                            <img alt='Up arrow' src={icArrowUp} className={classes.icon} onClick={onClick} style={{ opacity: click === true ? 0 : 1 }} />
                                            <img alt='Down arrow' src={icArrowDown} className={classes.icon} style={{ opacity: click === false ? 0 : 1 }} onClick={onClick} />
                                        </div>
                                    </Box>
                            }

                        </Box>
                    </Box>
                    <Box height='60vh' style={{ overflow: 'auto' }}>
                        {
                            dataFilter.map((item, index) => (
                                <Box key={'channel' + index} display='flex' px={3} py={2} mt={1} bgcolor='white'>
                                    <Box flexGrow={1} display='flex' alignItems='center'>
                                        <Box style={{ visibility: checkPermission() ? "hidden" : "visible" }} display='flex' width={100} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                            <Checkbox color='primary' checked={item.checked ? true : false} onChange={(event) => handleCheckMark(event, index, false)}></Checkbox>
                                        </Box>
                                        <Box display='flex' width={50} whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'>
                                            <Typography style={{ letterSpacing: 'normal', fontFamily: 'UniviaPro-Medium', fontWeight: 500 }}>{item.id}</Typography>
                                        </Box>
                                        {
                                            item.edit ?
                                                (
                                                    <Box display='flex'>
                                                        <TextField
                                                            disabled={item.loading}
                                                            error={item.error !== undefined}
                                                            helperText={item.error}
                                                            onKeyDown={(event) => {
                                                                event.key === 'Enter' && (handleOutFocus(item.editName, index))
                                                            }}
                                                            value={item.editName}
                                                            onChange={(event) => onChangeText(event, index)}
                                                            autoFocus={true} id="standard-basic" />
                                                        <Box ml={2} display='flex' height={25}>
                                                            <Button
                                                                disabled={item.loading}
                                                                size='small'
                                                                style={{ height: 25 }}
                                                                color='primary'
                                                                onClick={() => handleOutFocus(item.editName, index)}
                                                                variant='contained'>
                                                                {item.loading ? (
                                                                    <CircularProgress
                                                                        size={15}
                                                                        thickness={2}
                                                                        color='inherit'
                                                                    />
                                                                ) :
                                                                    translate(`pos.common.save`)
                                                                }
                                                            </Button>
                                                            <Box ml={1} display='flex' alignItems='flex-end'>
                                                                <Typography variant='subtitle2' color='primary'
                                                                    style={{ cursor: 'pointer', verticalAlign: 'bottom' }}
                                                                    onClick={() => onCancel(index)}>
                                                                    {translate(`pos.common.cancel`)}
                                                                </Typography>
                                                            </Box>
                                                        </Box>

                                                    </Box>
                                                )
                                                :
                                                (
                                                    permissions.functionAction.find(value => value.function === 'Info channel (Management)' && value.isUpdate) ?
                                                        <Typography
                                                            style={{
                                                                cursor: 'pointer', textDecorationLine: 'none',
                                                                letterSpacing: 'normal', fontFamily: 'UniviaPro-Medium',
                                                                fontWeight: 500, textOverflow: 'ellipsis',
                                                                overflow: 'hidden', whiteSpace: 'pre',
                                                                width: '600px'
                                                            }}
                                                            color='primary'
                                                            component={Link} to={'/infochannel/' + item.id}
                                                            variant='body1'>
                                                            {item.name}
                                                        </Typography> :
                                                        <Typography
                                                            style={{
                                                                cursor: 'pointer', textDecorationLine: 'none',
                                                                letterSpacing: 'normal', fontFamily: 'UniviaPro-Medium',
                                                                fontWeight: 500, textOverflow: 'ellipsis',
                                                                overflow: 'hidden', whiteSpace: 'pre',
                                                                width: '600px'
                                                            }}
                                                            color='primary'
                                                            variant='body1'>
                                                            {item.name}
                                                        </Typography>
                                                )

                                        }

                                    </Box>
                                    {
                                        permissions.functionAction.find(value => value.function === 'Info channel (Management)' && value.isUpdate) &&
                                        <Box display='flex' justifyContent='flex-end' alignItems='center'>
                                            <Box mr={2}>
                                                <Button
                                                    variant='contained'
                                                    // large
                                                    color='primary'
                                                    onClick={() => onActionMenuClick(item)}
                                                >
                                                    {translate(`pos.common.edit`)}
                                                </Button>
                                                {/* <Button variant='contained' color='primary' component={Link} to={'/infochannel/' + item.id}>
                                                    <Typography className={classes.textEdit} style={{ padding: '8px' }}>{translate(`pos.common.edit`)}</Typography>
                                                // </Button> */}
                                            </Box>
                                            <ActionItem icon={
                                                <img src={icBlueAdd} width={16} height={16}></img>}
                                                isEdit={item.edit}
                                                isGenerated={!item.loading}
                                                isDelete={openConfirmDialog}
                                                content={
                                                    <List
                                                        component="nav"
                                                        aria-labelledby="nested-list-subheader"
                                                    >
                                                        <ListItem style={{ marginBottom: 8 }} button onClick={() => handleClickReName(item.name, index)}>
                                                            <img src={icPen} width={15} height={15} />
                                                            <Typography style={{ marginLeft: 16, fontWeight: 'normal', fontFamily: 'UniviaPro', fontSize: '12px', lineHeight: '16.3px', letterSpacing: '0.13px' }}>
                                                                {translate(`pos.categories.Rename`)}
                                                            </Typography>
                                                        </ListItem>
                                                        <ListItem style={{ marginBottom: 8 }} button onClick={() => handleClickGenerateTVChannel(item, index)} disabled={item.loading}>
                                                            {
                                                                item.loading ? <CircularProgress
                                                                    size={15}
                                                                    thickness={2}
                                                                    color='inherit'
                                                                />
                                                                    :
                                                                    <img src={icTv} width={15} height={15} />
                                                            }
                                                            <Typography style={{ marginLeft: 16, fontWeight: 'normal', fontFamily: 'UniviaPro', fontSize: '12px', lineHeight: '16.3px', letterSpacing: '0.13px' }}>
                                                                {translate(`pos.infochannel.generateTVChannel`)}
                                                            </Typography>


                                                        </ListItem>
                                                        <ListItem button onClick={() => {
                                                            setOpenConfirmDialog({
                                                                status: true,
                                                                index: index
                                                            })
                                                        }}>
                                                            <img src={icDelete} width={15} height={15} />
                                                            <Typography style={{ marginLeft: 16, fontWeight: 'normal', fontFamily: 'UniviaPro', fontSize: '12px', lineHeight: '16.3px', letterSpacing: '0.13px' }}>
                                                                {translate(`pos.common.delete`)}
                                                            </Typography>
                                                        </ListItem>
                                                    </List>
                                                }
                                            />
                                        </Box>
                                    }

                                </Box>
                            ))
                        }
                    </Box>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog.status}
                handleClose={() => { setOpenConfirmDialog({ status: false, index: -1 }) }}
                handleConfirm={handleOnDelete}
                ContentText={translate('pos.user.contentDelete')}
                Tittle={translate('pos.infochannel.delete')} />
            {/* 
            <Dialog open={showMessagePopup} scroll='paper'>
                <Box display='flex' justifyContent='flex-end' alignContent='center' mr={2} mt={2}>
                    <IconRadiusButton onClick={onCloseMessagePopup}>
                        <Close color='primary' />
                    </IconRadiusButton>
                </Box>
                <DialogContent>
                    <Box mx={2.5} className={classes.dialogContent}>
                        {messagePopupContent}
                    </Box>
                </DialogContent>
            </Dialog> */}
        </Box>
    )
}
export default InfoChannels